import { WIDGET_SHAPE_TYPE } from "@ever-tutor/et-widgets/tldraw";
import { Box } from "tldraw";
import { convertTldrawShapesToPeripheralShapes } from "../../shared/format/convertTldrawShapesToPeripheralShapes";
import { PeripheralShapesPart } from "../../shared/types/PromptPart";
import { AgentRequest } from "../../shared/types/AgentRequest";
import { AgentHelpers } from "../AgentHelpers";
import { PromptPartUtil, registerPromptPartUtil } from "./PromptPartUtil";

export const PeripheralShapesPartUtil = registerPromptPartUtil(
  class PeripheralShapesPartUtil extends PromptPartUtil<PeripheralShapesPart> {
    static override type = "peripheralShapes" as const;

    override getPart(
      request: AgentRequest,
      helpers: AgentHelpers,
    ): PeripheralShapesPart {
      const { editor } = this;

      const shapes = editor
        .getCurrentPageShapesSorted()
        .filter((shape) => shape.type !== WIDGET_SHAPE_TYPE);
      const contextBounds = request.bounds;

      const contextBoundsBox = Box.From(contextBounds);

      // Get all shapes that are outside the context bounds (these are what we want to peripheralize)
      const shapesOutsideViewport = shapes.filter((shape) => {
        const bounds = editor.getShapeMaskedPageBounds(shape);
        if (!bounds) return;
        if (contextBoundsBox.includes(bounds)) return;
        return true;
      });

      // Convert the shapes to peripheral shape cluster format
      const clusters = convertTldrawShapesToPeripheralShapes(
        editor,
        shapesOutsideViewport,
        {
          padding: 75,
        },
      );

      const normalizedClusters = clusters.map((cluster) => ({
        numberOfShapes: cluster.numberOfShapes,
        bounds: helpers.roundBox(cluster.bounds),
      }));

      return {
        type: "peripheralShapes",
        clusters: normalizedClusters,
      };
    }
  },
);
